import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/Continental_Twinduro_TKC80_Dual_Sport_Tires_300x300.jpg")